import { takeLatest, put, all, call } from 'redux-saga/effects';
import { encryptData } from '../../_common/enode-decode';
import AlertManager from '../../../utils/alertManager';
import groupOfficerReport from './group-officer-report.types';
import {
	getAllGroupOfficerReport,
	getAllCenterListForOfficer,
} from './group-officer-report.services';
import {
	// FETCH GROUP OFFICER RESPONSE
	fetchAllGroupOfficerReportSuccess,
	fetchAllGroupOfficerReportFailure,
	fetchAllGroupOfficerReportResponseResetChanged,

	// FETCH ALL CENTER LIST BASED ON OFFICER RESPONSE
	fetchAllCenterListForOfficerFailure,
	fetchAllCenterListForOfficerSuccess,
	fetchAllCenterListForOfficerResponseResetChanged,
} from './group-officer-report.action';

/** *********************  START ALL GROUP REPORT DETAILS  ******************** */
export function* getAllGroupOfficerReportReportDetails({ payload }: any) {
	try {
		const key = 'GetAllGroupOfficerReportKey';
		const {
			companyID,
			databaseName,
			branchID,
			funderID,
			IsPersonalLoan,
			centerID,
			toDate,
			fromDate,
			SearchType,
			UserID,
			UserRoleName,
			userLevel,
			groupID,
			officerID,
			generalCompanyID,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			BranchID: branchID,
			FunderID: funderID,
			IsPersonalLoan: IsPersonalLoan,
			Location: centerID,
			ToDate: toDate,
			FromDate: fromDate,
			TillDate: toDate,
			SearchType: SearchType,
			UserID: UserID,
			UserRole: UserRoleName,
			UserLevel: userLevel,
			GroupID: groupID,
			GroupOfficerID: officerID, //--
			DateFilter: SearchType, //---
			GeneralCompanyID: generalCompanyID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getAllGroupOfficerReport, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchAllGroupOfficerReportFailure(responseData.data));
		} else {
			yield put(fetchAllGroupOfficerReportSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchAllGroupOfficerReportFailure(error));
	}
}

export function* reserAllGroupOfficerReportReportResponse() {
	yield put(fetchAllGroupOfficerReportResponseResetChanged());
}

export function* onAllGroupOfficerReportReportDetail() {
	yield takeLatest(
		groupOfficerReport.GET_GROUP_OFFICER_REPORT_START,
		getAllGroupOfficerReportReportDetails,
	);
}

export function* onAllGroupOfficerReportReportDetailResponseReset() {
	yield takeLatest(
		groupOfficerReport.GET_GROUP_OFFICER_REPORT_RESPONSE_RESET_START,
		reserAllGroupOfficerReportReportResponse,
	);
}
/** *********************  END ALL GROUP REPORT DETAILS ******************** */

/** *********************  START ALL CENTER LIST BASED ON OFFICER DETAILS  ******************** */
export function* getAllCenterListForOfficerDetails({ payload }: any) {
	try {
		const key = 'GetAllCenterListForOfficerKey';
		const { databaseName, officerID, branchID, companyID } = payload;
		const jsonData = {
			DatabaseName: databaseName,
			BranchID: branchID,
			OfficerID: officerID,
			CompanyID: companyID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getAllCenterListForOfficer, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchAllCenterListForOfficerFailure(responseData.data));
		} else {
			yield put(fetchAllCenterListForOfficerSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchAllCenterListForOfficerFailure(error));
	}
}

export function* reserAllCenterListForOfficerResponse() {
	yield put(fetchAllCenterListForOfficerResponseResetChanged());
}

export function* onAllCenterListForOfficerDetail() {
	yield takeLatest(
		groupOfficerReport.GET_CENTER_LIST_FOR_OFFICER_START,
		getAllCenterListForOfficerDetails,
	);
}

export function* onAllCenterListForOfficerDetailResponseReset() {
	yield takeLatest(
		groupOfficerReport.GET_CENTER_LIST_FOR_OFFICER_RESPONSE_RESET_START,
		reserAllCenterListForOfficerResponse,
	);
}
/** *********************  END ALL CENTER LIST BASED ON OFFICER DETAILS ******************** */

export function* groupOfficerReportSaga() {
	yield all([
		// FETCH GROUP OFFICER RESPONSE
		call(onAllGroupOfficerReportReportDetail),
		call(onAllGroupOfficerReportReportDetailResponseReset),

		// FETCH ALL CENTER LIST BASED ON OFFICER RESPONSE
		call(onAllCenterListForOfficerDetail),
		call(onAllCenterListForOfficerDetailResponseReset),
	]);
}
